import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Box,
  Text,
  Spinner,
  useToast,
  Flex,
  VStack,
  HStack,
  Divider,
  Badge,
  SimpleGrid,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "components-lib";
import { axiosInstance } from "../../../config/api";

// Component for displaying detailed sections within each prescription
const DetailSection = ({ title, children }) => (
  <Box mb={4}>
    <Text fontWeight="bold" mb={2} fontSize="md" color="blue.600">
      {title}
    </Text>
    {children}
  </Box>
);

export const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  };
  return new Date(dateString).toLocaleDateString("en-US", options);
};

// // Component for individual prescription card with all details
// const PrescriptionCard = ({  visit, formatDate }) => (
//   <Box
//     border="1px"
//     borderColor="gray.200"
//     borderRadius="lg"
//     p={6}
//     bg="white"
//     shadow="sm"
//     _hover={{ shadow: "md" }}
//     transition="all 0.2s"
//   >
//     {/* Header Information */}
//     <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={4} mb={6}>
//       <Box>
//         <Text fontSize="sm" color="gray.500" fontWeight="medium">
//           Date
//         </Text>
//         <Text fontWeight="semibold" color="gray.800">
//           {formatDate(visit.appointment?.date)}
//         </Text>
//       </Box>
//       <Box>
//         <Text fontSize="sm" color="gray.500" fontWeight="medium">
//           Doctor
//         </Text>
//         <Text fontWeight="semibold" color="gray.800">
//           {visit.doctor?.name || "N/A"}
//         </Text>
//       </Box>
//       <Box>
//         <Text fontSize="sm" color="gray.500" fontWeight="medium">
//           Patient
//         </Text>
//         <Text fontWeight="semibold" color="gray.800">
//           {visit.patient?.name} (ID: {visit.patient?.id})
//         </Text>
//       </Box>
//       <Box>
//         <Text fontSize="sm" color="gray.500" fontWeight="medium">
//           Clinic
//         </Text>
//         <Text fontWeight="semibold" color="gray.800">
//           {visit.clinic?.name || "N/A"}
//         </Text>
//       </Box>
//     </SimpleGrid>

//     <Divider mb={6} />

//     {/* Detailed Information Sections */}
//     <VStack spacing={6} align="stretch">
//       {/* Diagnosis Section */}
//       <DetailSection title="Diagnosis">
//         <Box
//           bg="blue.50"
//           p={4}
//           borderRadius="md"
//           borderLeft="4px"
//           borderColor="blue.400"
//         >
//           <Text fontWeight="medium" color="gray.800">
//             {visit.diagnosis?.diagnosis || "No diagnosis recorded"}
//           </Text>
//           {visit.diagnosis?.duration && (
//             <Text color="gray.600" mt={1} fontSize="sm">
//               Duration: {visit.diagnosis.duration}
//             </Text>
//           )}
//         </Box>
//       </DetailSection>

//       {/* Complaints Section */}
//       <DetailSection title="Complaints">
//         <Box
//           bg="orange.50"
//           p={4}
//           borderRadius="md"
//           borderLeft="4px"
//           borderColor="orange.400"
//         >
//           {visit.complaints?.complaint ? (
//             <VStack align="stretch" spacing={2}>
//               <Text fontWeight="medium" color="gray.800">
//                 {visit.complaints.complaint}
//               </Text>
//               <HStack spacing={4}>
//                 <Text fontSize="sm">
//                   <Text as="span" color="gray.600" fontWeight="medium">
//                     Severity:
//                   </Text>{" "}
//                   <Badge
//                     colorScheme={
//                       visit.complaints.severity === "High"
//                         ? "red"
//                         : visit.complaints.severity === "Medium"
//                         ? "orange"
//                         : "green"
//                     }
//                   >
//                     {visit.complaints.severity}
//                   </Badge>
//                 </Text>
//                 <Text fontSize="sm">
//                   <Text as="span" color="gray.600" fontWeight="medium">
//                     Duration:
//                   </Text>{" "}
//                   {visit.complaints.duration}
//                 </Text>
//               </HStack>
//             </VStack>
//           ) : (
//             <Text color="gray.600">No complaints recorded</Text>
//           )}
//         </Box>
//       </DetailSection>

//       {/* Medications Section */}
//       <DetailSection title="Medications">
//         <Box
//           bg="green.50"
//           p={4}
//           borderRadius="md"
//           borderLeft="4px"
//           borderColor="green.400"
//         >
//           {visit.medicines?.name ? (
//             <VStack align="stretch" spacing={3}>
//               <Box>
//                 <Text fontWeight="semibold" color="gray.800" fontSize="md">
//                   {visit.medicines.name}
//                 </Text>
//                 <SimpleGrid columns={{ base: 1, md: 2 }} spacing={2} mt={2}>
//                   <Text fontSize="sm">
//                     <Text as="span" color="gray.600" fontWeight="medium">
//                       Dosage:
//                     </Text>{" "}
//                     {visit.medicines.dosage}
//                   </Text>
//                   <Text fontSize="sm">
//                     <Text as="span" color="gray.600" fontWeight="medium">
//                       Frequency:
//                     </Text>{" "}
//                     {visit.medicines.frequency}
//                   </Text>
//                   <Text fontSize="sm">
//                     <Text as="span" color="gray.600" fontWeight="medium">
//                       Duration:
//                     </Text>{" "}
//                     {visit.medicines.duration}
//                   </Text>
//                   {visit.medicines.when_to_take && (
//                     <Text fontSize="sm">
//                       <Text as="span" color="gray.600" fontWeight="medium">
//                         When to take:
//                       </Text>{" "}
//                       {visit.medicines.when_to_take}
//                     </Text>
//                   )}
//                 </SimpleGrid>
//               </Box>
//             </VStack>
//           ) : (
//             <Text color="gray.600">No medications prescribed</Text>
//           )}
//         </Box>
//       </DetailSection>

//       {/* Allergies Section */}
//       <DetailSection title="Allergies">
//         <Box
//           bg="red.50"
//           p={4}
//           borderRadius="md"
//           borderLeft="4px"
//           borderColor="red.400"
//         >
//           {visit.allergies ? (
//             <VStack align="stretch" spacing={1}>
//               {visit.allergies.medicines && (
//                 <Text fontSize="sm">
//                   <Text as="span" color="gray.600" fontWeight="medium">
//                     Medicines:
//                   </Text>{" "}
//                   {visit.allergies.medicines}
//                 </Text>
//               )}
//               {visit.allergies.food && (
//                 <Text fontSize="sm">
//                   <Text as="span" color="gray.600" fontWeight="medium">
//                     Food:
//                   </Text>{" "}
//                   {visit.allergies.food}
//                 </Text>
//               )}
//               {visit.allergies.others && (
//                 <Text fontSize="sm">
//                   <Text as="span" color="gray.600" fontWeight="medium">
//                     Others:
//                   </Text>{" "}
//                   {visit.allergies.others}
//                 </Text>
//               )}
//               {!visit.allergies.medicines &&
//                 !visit.allergies.food &&
//                 !visit.allergies.others && (
//                   <Text color="gray.600">No known allergies</Text>
//                 )}
//             </VStack>
//           ) : (
//             <Text color="gray.600">No allergy information available</Text>
//           )}
//         </Box>
//       </DetailSection>

//       {/* Doctor's Advice Section */}
//       <DetailSection title="Doctor's Advice">
//         <Box
//           bg="purple.50"
//           p={4}
//           borderRadius="md"
//           borderLeft="4px"
//           borderColor="purple.400"
//         >
//           <Text color="gray.800">
//             {visit.advice?.advice_text || "No specific advice given"}
//           </Text>
//         </Box>
//       </DetailSection>

//       {/* Next Visit Section */}
//       {visit.prescription?.next_visit && (
//         <DetailSection title="Next Visit">
//           <Box
//             bg="teal.50"
//             p={4}
//             borderRadius="md"
//             borderLeft="4px"
//             borderColor="teal.400"
//           >
//             <Text fontWeight="medium" color="gray.800">
//               {formatDate(visit.prescription.next_visit)}
//             </Text>
//             {visit.prescription.referred_to && (
//               <Text mt={1} fontSize="sm">
//                 <Text as="span" color="gray.600" fontWeight="medium">
//                   Referred to:
//                 </Text>{" "}
//                 {visit.prescription.referred_to}
//               </Text>
//             )}
//           </Box>
//         </DetailSection>
//       )}
//     </VStack>
//   </Box>
// );

// Component for individual prescription card with all details
export const PrescriptionCard = ({ data, formatDate, ispasthistory,isallergies }) => {
  const {
    prescription,
    appointment,
    doctor,
    doctor_id,
    patient,
    clinic,
    allergies,
    diagnosis,
    past_history,
    medicines,
    advice,
    complaints,
    clinical_findings,
    referred_to,
  } = data;

  return (
    <Box
      border="1px"
      borderColor="gray.200"
      borderRadius="lg"
      p={6}
      bg="white"
      shadow="sm"
      _hover={{ shadow: "md" }}
      transition="all 0.2s"
    >
      {/* Header Information */}
      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={4} mb={6}>
        <Box>
          <Text fontSize="sm" color="gray.500" fontWeight="medium">
            Date
          </Text>
          <Text fontWeight="semibold" color="gray.800">
            {formatDate(appointment?.date)} {appointment?.time}
          </Text>
        </Box>
        {/* {doctor_id != null && (
          <Box>
            <Text fontSize="sm" color="gray.500" fontWeight="medium">
              Doctor
            </Text>
            <Text fontWeight="semibold" color="gray.800">
              {doctor_id || "N/A"}
            </Text>
          </Box>
        )}
        {patient && (
          <Box>
            <Text fontSize="sm" color="gray.500" fontWeight="medium">
              Patient
            </Text>
            <Text fontWeight="semibold" color="gray.800">
              {patient?.name} (ID: {patient?.id})
            </Text>
          </Box>
        )}
        <Box>
          <Text fontSize="sm" color="gray.500" fontWeight="medium">
            Clinic
          </Text>
          <Text fontWeight="semibold" color="gray.800">
            {clinic?.name || "N/A"}
          </Text>
        </Box> */}
      </SimpleGrid>

      <Divider mb={6} />

      <VStack spacing={6} align="stretch">
        {/* Diagnosis Section */}
        <DetailSection title="Diagnosis">
          <Box
            bg="blue.50"
            p={4}
            borderRadius="md"
            borderLeft="4px"
            borderColor="blue.400"
          >
            {diagnosis?.length > 0 ? (
              <VStack align="stretch" spacing={2}>
                {diagnosis.map((d) => (
                  <Text key={d.id} fontWeight="medium" color="gray.800">
                    • {d.diagnosis}
                  </Text>
                ))}
              </VStack>
            ) : (
              <Text color="gray.600">No diagnosis recorded</Text>
            )}
          </Box>
        </DetailSection>
        {/* Complaints Section */}
        <DetailSection title="Complaints">
          <Box
            bg="orange.50"
            p={4}
            borderRadius="md"
            borderLeft="4px"
            borderColor="orange.400"
          >
            {complaints?.length > 0 ? (
              <VStack align="stretch" spacing={3}>
                {complaints.map((c) => (
                  <Box key={c.id}>
                    <Text fontWeight="medium" color="gray.800">
                      {c.complaint}
                    </Text>
                    <HStack spacing={4}>
                      <Text fontSize="sm">
                        <Text as="span" color="gray.600" fontWeight="medium">
                          Severity:
                        </Text>{" "}
                        <Badge
                          colorScheme={
                            c.severity?.toLowerCase() === "high"
                              ? "red"
                              : c.severity?.toLowerCase() === "moderate"
                              ? "orange"
                              : c.severity?.toLowerCase() === "mild"
                              ? "green"
                              : "gray"
                          }
                        >
                          {c.severity}
                        </Badge>
                      </Text>
                      <Text fontSize="sm">
                        <Text as="span" color="gray.600" fontWeight="medium">
                          Duration:
                        </Text>{" "}
                        {c.duration}
                      </Text>
                    </HStack>
                  </Box>
                ))}
              </VStack>
            ) : (
              <Text color="gray.600">No complaints recorded</Text>
            )}
          </Box>
        </DetailSection>
        {/* Past History Section */}
        { ispasthistory &&(
          <DetailSection title="Past History">
            <Box
              bg="gray.50"
              p={4}
              borderRadius="md"
              borderLeft="4px"
              borderColor="gray.400"
            >
              {past_history?.length > 0 ? (
                <VStack align="stretch" spacing={3}>
                  {past_history.map((h) => (
                    <Box key={h.history_no || h.id}>
                      <Text fontWeight="medium" color="gray.800">
                        {h.history}
                      </Text>
                      <HStack spacing={4} mt={2}>
                        <Text fontSize="sm">
                          <Text as="span" color="gray.600" fontWeight="medium">
                            Duration:
                          </Text>{" "}
                          {h.duration}
                        </Text>

                        {h.date && (
                          <Text fontSize="sm">
                            <Text as="span" color="gray.600" fontWeight="medium">
                              Date:
                            </Text>{" "}
                            {formatDate(h.date)}
                          </Text>
                        )}
                      </HStack>
                    </Box>
                  ))}
                </VStack>
              ) : (
                <Text color="gray.600">No past history recorded</Text>
              )}
            </Box>
          </DetailSection>)}
        {/* Medications Section */}
        <DetailSection title="Medications">
          <Box
            bg="green.50"
            p={4}
            borderRadius="md"
            borderLeft="4px"
            borderColor="green.400"
          >
            {medicines?.length > 0 ? (
              <VStack align="stretch" spacing={3}>
                {medicines.map((m) => (
                  <Box key={m.id}>
                    <Text fontWeight="semibold" color="gray.800" fontSize="md">
                      {m.name}
                    </Text>
                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={2} mt={2}>
                      <Text fontSize="sm">
                        <b>Dosage:</b> {m.dosage} {m.type}
                      </Text>
                      <Text fontSize="sm">
                        <b>Frequency:</b> {m.frequency}
                      </Text>
                      <Text fontSize="sm">
                        <b>Duration:</b> {m.duration}
                      </Text>
                      {m.when_to_take && (
                        <Text fontSize="sm">
                          <b>When to take:</b> {m.when_to_take}
                        </Text>
                      )}
                    </SimpleGrid>
                  </Box>
                ))}
              </VStack>
            ) : (
              <Text color="gray.600">No medications prescribed</Text>
            )}
          </Box>
        </DetailSection>
        {/* Allergies Section */}
        {isallergies && (
          <DetailSection title="Allergies">
            <Box
              bg="red.50"
              p={4}
              borderRadius="md"
              borderLeft="4px"
              borderColor="red.400"
            >
              {allergies?.length > 0 ? (
                <VStack align="stretch" spacing={2}>
                  {allergies.map((a) => (
                    <Box key={a.id}>
                      {a.medicines && (
                        <Text fontSize="sm">
                          <b>Medicines:</b> {a.medicines}
                        </Text>
                      )}
                      {a.food && (
                        <Text fontSize="sm">
                          <b>Food:</b> {a.food}
                        </Text>
                      )}
                      {a.others && (
                        <Text fontSize="sm">
                          <b>Others:</b> {a.others}
                        </Text>
                      )}
                    </Box>
                  ))}
                </VStack>
              ) : (
                <Text color="gray.600">No allergy information available</Text>
              )}
            </Box>
          </DetailSection>)}
        {/* Clinical Findings Section */}
        <DetailSection title="Clinical Findings">
          <Box
            bg="pink.50"
            p={4}
            borderRadius="md"
            borderLeft="4px"
            borderColor="pink.400"
          >
            {clinical_findings?.length > 0 ? (
              <VStack align="stretch" spacing={1}>
                {clinical_findings.map((f) => (
                  <Text key={f.id} color="gray.800">
                    • {f.finding}
                  </Text>
                ))}
              </VStack>
            ) : (
              <Text color="gray.600">No clinical findings recorded</Text>
            )}
          </Box>
        </DetailSection>
        {/* Doctor's Advice Section */}
        <DetailSection title="Doctor's Advice">
          <Box
            bg="purple.50"
            p={4}
            borderRadius="md"
            borderLeft="4px"
            borderColor="purple.400"
          >
            {advice?.length > 0 ? (
              <VStack align="stretch" spacing={1}>
                {advice.map((a) => (
                  <Text key={a.id} color="gray.800">
                    • {a.advice_text}
                  </Text>
                ))}
              </VStack>
            ) : (
              <Text color="gray.600">No specific advice given</Text>
            )}
          </Box>
        </DetailSection>
        {/* Next Visit Section */}
        {prescription?.next_visit && (
          <DetailSection title="Next Visit">
            <Box
              bg="teal.50"
              p={4}
              borderRadius="md"
              borderLeft="4px"
              borderColor="teal.400"
            >
              <Text fontWeight="medium" color="gray.800">
                {formatDate(prescription.next_visit)}
              </Text>
              <Text fontWeight="medium" color="gray.800">
                Referred To:
              </Text>

              {/* Referred To Section */}
              {referred_to?.length > 0 && (
                <VStack align="stretch" mt={3} spacing={2}>
                  {referred_to.map((r) => (
                    <Box
                      key={r.id}
                      border="1px"
                      borderColor="gray.200"
                      borderRadius="md"
                      p={3}
                      bg="white"
                    >
                      <Text fontWeight="medium" color="gray.800">
                        {r.referred_doctor_name}
                      </Text>
                      {r.hospital && (
                        <Text fontSize="sm">
                          <b>Hospital:</b> {r.hospital}
                        </Text>
                      )}
                      {r.hospital_address && (
                        <Text fontSize="sm">
                          <b>Address:</b> {r.hospital_address}
                        </Text>
                      )}
                      {r.phone && (
                        <Text fontSize="sm">
                          <b>Phone:</b> {r.phone}
                        </Text>
                      )}
                      {r.email && (
                        <Text fontSize="sm">
                          <b>Email:</b> {r.email}
                        </Text>
                      )}
                      {r.date && (
                        <Text fontSize="sm">
                          <b>Date:</b> {formatDate(r.date)}
                        </Text>
                      )}
                    </Box>
                  ))}
                </VStack>
              )}
            </Box>
          </DetailSection>
        )}
        {/* Investigation Section */}
        <DetailSection title="Investigation">
          <Box
            bg="yellow.50"
            p={4}
            borderRadius="md"
            borderLeft="4px"
            borderColor="yellow.400"
          >
            {prescription?.investigation ? (
              <Text color="gray.800">{prescription.investigation}</Text>
            ) : (
              <Text color="gray.600">No investigations recorded</Text>
            )}
          </Box>
        </DetailSection>
        {/* Past Medication Section */}
        <DetailSection title="Past Medication">
          <Box
            bg="cyan.50"
            p={4}
            borderRadius="md"
            borderLeft="4px"
            borderColor="cyan.400"
          >
            {prescription?.past_medication ? (
              <Text color="gray.800">{prescription.past_medication}</Text>
            ) : (
              <Text color="gray.600">No past medication recorded</Text>
            )}
          </Box>
        </DetailSection>
      </VStack>
    </Box>
  );
};

const PastVisitsModal = ({
  isOpen,
  onClose,
  patientId,
  setPastpatientSpecifcData,
  pastAppointments: externalPastAppointments = [],
  prescriptionData: externalPrescriptionData = null,
  isLoading: externalLoading = false,
  error: externalError = null,
  skipInternalFetch = false,
}) => {
  // Internal state only used when NOT skipping fetch
  const [pastAppointments, setPastAppointments] = useState([]);
  const [isLoadingInternal, setIsLoadingInternal] = useState(false);
  const [errorInternal, setErrorInternal] = useState(null);
  const [prescriptionData, setPrescriptionData] = useState({});
  const isMounted = useRef(true);
  const toast = useToast();

  // Derived display sources
  const displayPastAppointments = skipInternalFetch
    ? externalPastAppointments || []
    : pastAppointments;
  const displayPrescriptionData = skipInternalFetch
    ? externalPrescriptionData
    : prescriptionData;
  const isLoading = skipInternalFetch ? externalLoading : isLoadingInternal;
  const error = skipInternalFetch ? externalError : errorInternal;

  useEffect(() => {
    if (!isOpen) return;
    if (skipInternalFetch) return;

    let mounted = true;
    const fetchPastAppointments = async () => {
      if (!patientId) {
        if (mounted) {
          setErrorInternal("No patient ID provided");
        }
        return;
      }
      setIsLoadingInternal(true);
      setErrorInternal(null);
      try {
        const response = await axiosInstance.get(
          `api/prescription/getPrescriptions?latest=true&patient_id=${patientId}`
        );
        if (mounted && response.data.success) {
          setPastAppointments(response.data.data || []);
          if (response.data.data?.[0]?.prescription_id) {
            const PrescriptionData = await axiosInstance.get(
              `api/prescription/getPrescriptionById?id=${response.data.data[0].prescription_id}`
            );
            if (PrescriptionData.data.success) {
              setPrescriptionData(PrescriptionData.data || {});
              const src = PrescriptionData.data?.data || {};
              const past_history = src.past_history ?? src.pastHistory ?? [];
              const allergies = src.allergies ?? [];
              setPastpatientSpecifcData?.({ past_history, allergies });
            }
          }
        } else if (mounted) {
          setErrorInternal("No prescription data found");
        }
      } catch (err) {
        if (mounted) {
          setErrorInternal(
            "Failed to load past appointments. Please try again."
          );
          toast({
            title: "Error",
            description:
              "Failed to load past appointments. " +
              (err.response?.data?.message || ""),
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        }
      } finally {
        if (mounted) setIsLoadingInternal(false);
      }
    };

    fetchPastAppointments();
    return () => {
      mounted = false;
    };
  }, [isOpen, patientId, skipInternalFetch, setPastpatientSpecifcData, toast]);

  // Utility function to format dates consistently

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent
        maxW="95vw"
        maxH="95vh"
        border="8px"
        borderColor="gray.100"
        borderRadius="5px"
      >
        <ModalHeader bg="blue.100" borderColor="gray.100" borderRadius="5px">
          <Flex justify="space-between" align="center">
            <Text fontSize="xl" fontWeight="semibold">
              Prescription History
            </Text>
            <ModalCloseButton position="relative" top={0} right={0} />
          </Flex>
        </ModalHeader>

        <ModalBody p={6} bg="gray.50">
          {isLoading ? (
            <Box p={8} textAlign="center">
              <Spinner size="xl" color="blue.500" />
              <Text mt={4} color="gray.600">
                Loading prescription history...
              </Text>
            </Box>
          ) : error ? (
            <Box p={8} textAlign="center">
              <Text color="red.500" fontSize="lg">
                {error}
              </Text>
            </Box>
          ) : displayPastAppointments.length === 0 ||
            !displayPrescriptionData ? (
            <Box p={8} textAlign="center">
              <Text color="gray.600" fontSize="lg">
                No past appointments found.
              </Text>
            </Box>
          ) : (
            <VStack spacing={6} align="stretch">
              <Box
                bg="white"
                p={4}
                borderRadius="lg"
                shadow="sm"
                border="1px"
                borderColor="gray.200"
              >
                <Text fontSize="lg" fontWeight="semibold" color="gray.800">
                  Found {displayPastAppointments.length} prescription
                  {displayPastAppointments.length !== 1 ? "s" : ""} in history
                </Text>
                <Text fontSize="sm" color="gray.600" mt={1}>
                  Latest prescription details shown below
                </Text>
              </Box>

              <PrescriptionCard
                data={displayPrescriptionData?.data}
                formatDate={formatDate}
              />
            </VStack>
          )}
        </ModalBody>

        <ModalFooter
          borderTop="1px"
          borderColor="gray.200"
          bg="white"
          borderRadius="0 0 5px 5px"
        >
          <Button colorScheme="blue" onClick={onClose} size="lg">
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default PastVisitsModal;
